import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import PromoMessage from '../../promo-message';

class Component extends BaseComponent {
    render() {
        return (
            <daily-number-mobile>
                {this.renderContent()}
            </daily-number-mobile>
        );
    }

    renderContent = () => {
        if (this.props.number) {
            const number = this.props.number;

            return [
                <h1>Number of the Day</h1>,
                <a class='nod-attribution' href='/bios/hans-decoz' rel='author'>by Hans Decoz</a>,
                <div class={`today-number nod-${number.number}`} />,
                <div>
                    <div class='todays-numbers'>Today's numbers are: {number.numbers.join(', ')}</div>
                    <h2>Your Daily Number: {number.number}</h2>
                    <h5>{number.title}</h5>
                    {number.body.map(p => (<p>{p}</p>))}
                    <p><PromoMessage placement='text-number' /></p>
                </div>,
            ];
        }

        return [
            <h1>Number of the Day</h1>,
            <img src='https://gfx.tarot.com/images/daily-pages/daily-icons/number.svg' alt='Daily Number' />,
            <h2>Create Your Profile To Find Out!</h2>,
            <p>
                Looking for your Number of the Day? Create your profile to receive a number that's personalized
                to YOU every day!
            </p>,
            <a href='/signup?return' class='button'>CREATE MY PROFILE</a>,
            <p class='signup_promo_text'>Already a Tarot.com member? <a href='/login'>Login Now</a></p>,
        ];
    }
}

const mapStateToProps = (state) => ({
    number: state.number,
});

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/daily/number/mobile.js